import { InternalChainId, TokenSymbol } from "@cede/types";
import { TokenIcon } from "@cede/types";
import { ENVIRONMENTS } from "../environment";
import DEFAULT_NETWORK_ICON_SVG from "./defaultNetwork.svg.js";
import DEFAULT_TOKEN_ICON_SVG from "./defaultToken.svg.js";
import { CDN_MODULES } from "./types";

export const CEDE_CDN_URL = "https://cdn.cedelabs.io";
export const CEDE_CDN_URL_DEV = "https://cdn-dev.cedelabs.io";
export const CEDE_CDN_URL_STAGING = "https://cdn-staging.cedelabs.io";
export const CEDE_CDN_URL_BY_ENV = {
  [ENVIRONMENTS.DEVELOPMENT]: CEDE_CDN_URL_DEV,
  [ENVIRONMENTS.PRODUCTION]: CEDE_CDN_URL,
  [ENVIRONMENTS.CRON_WORKER]: CEDE_CDN_URL,
  [ENVIRONMENTS.LOCAL]: CEDE_CDN_URL_DEV,
  [ENVIRONMENTS.STAGING]: CEDE_CDN_URL_STAGING,
  [ENVIRONMENTS.TEST]: CEDE_CDN_URL_DEV,
};

// Convert SVG strings to data URLs
const svgToDataUrl = (svgContent: string): string => {
  const encodedSvg = encodeURIComponent(svgContent);
  return `data:image/svg+xml,${encodedSvg}`;
};

export const DEFAULT_NETWORK_ICON = svgToDataUrl(DEFAULT_NETWORK_ICON_SVG);
export const DEFAULT_TOKEN_ICON = svgToDataUrl(DEFAULT_TOKEN_ICON_SVG);
// Icons from CoinMarketCap
let icons: TokenIcon[] = [];

export async function fetchIcons(fetcher: () => Promise<{ data: TokenIcon[] }>) {
  const { data } = await fetcher();
  icons = data;
}

export const forgeCDNUrl = (module: CDN_MODULES, path: string, cdnUrl?: string) =>
  `${cdnUrl ?? CEDE_CDN_URL}/${module}/${path}`;

export const forgeCDNUrlByEnv = (path: string, env: ENVIRONMENTS = ENVIRONMENTS.PRODUCTION) => {
  const cdnUrl = CEDE_CDN_URL_BY_ENV[env] || CEDE_CDN_URL_DEV;
  return `${cdnUrl}/${path}`;
};

export const forgeNetworkURL = (icid?: InternalChainId): string => {
  if (!icid) return DEFAULT_NETWORK_ICON;
  return forgeCDNUrl(CDN_MODULES.NETWORK, `${icid}.png`);
};

export const forgeTokenURL = (token?: TokenSymbol): string => {
  if (!token) return DEFAULT_TOKEN_ICON;
  return forgeCDNUrl(CDN_MODULES.TOKEN, `${token.toLowerCase()}.svg`);
};

export const resolveCDNMiss = (url: URL) => {
  const path = url.pathname.split("/");
  if (path.length < 3) return "";

  const module = path[1];
  const target = path[2]?.replace(".png", "").replace(".svg", "");
  switch (module) {
    case CDN_MODULES.NETWORK:
      return DEFAULT_NETWORK_ICON;
    case CDN_MODULES.TOKEN: {
      const icon = icons.find((icon) => icon.token.toLowerCase() === target);
      return icon ? svgToDataUrl(icon.icon) : DEFAULT_TOKEN_ICON;
    }
    default:
      return "";
  }
};

export * from "./types";
